// Accesos rapidos almacenados por usuario, empresa y sucursal en ESTE navegador.
// No afectan el catalogo ni son fuente de verdad del inventario.
export function productKey(product) {
  return product?.is_virtual_extra
    ? `extra:${String(product.extra_option_id)}`
    : `product:${String(product?.id)}`;
}
export function rememberQuickKey(list, key, limit = 12) {
  const cleaned = Array.isArray(list) ? list.filter(value => typeof value === 'string' && value !== key) : [];
  return [key, ...cleaned].slice(0, limit);
}
export function toggleQuickKey(list, key, limit = 150) {
  const cleaned = Array.isArray(list) ? list.filter(value => typeof value === 'string') : [];
  return cleaned.includes(key) ? cleaned.filter(value => value !== key) : [...cleaned, key].slice(-limit);
}
export function readQuickList(storageKey) {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
    return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string'))] : [];
  } catch (_error) { return []; }
}
